const defaultState = () => {
  return {
    mnemonicStates: {},
  };
};

const getters = {
  mnemonicStates: state => state.mnemonicStates,
};

const mutations = {
  setMnemonicStates(state, mnemonicStates) {
    for(let mnemonicState of mnemonicStates) {
      state.mnemonicStates[mnemonicState.mnemonicId] = mnemonicState;
    }
  },
  reset(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
  sendMnemonicState({ dispatch, commit, getters, rootGetters }, params) {
    commit('setMnemonicStates', [params]);
    return rootGetters['session/ajax'].post('/mnemonic_states', params).then(response => {
      return response;
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
